import classNames from 'classnames/bind';
import React from 'react';

import Console from './Console';
import styles from './index.module.scss';

import { PrimaryButton } from '@/components/ui/kit/Button';
import ModalWrapper from '@/components/ui/ModalWrapper';
import { modalManager } from '@/libs/ModalContainer';

const cx = classNames.bind(styles);

const Modal = ({ robot }) => {
  const close = () => {
    modalManager.hide();
  };

  return (
    <ModalWrapper className={cx('container')}>
      <div className={cx('content')}>
        <Console robot={robot} />
      </div>
      <PrimaryButton text="Close" center onClick={close} />
    </ModalWrapper>
  );
};

export default Modal;
